// ──────────────────────────────────────────────
// IDs centralizados — NUNCA hardcodear IDs en componentes
// ──────────────────────────────────────────────

// Socios / dueños de la plataforma
export const ADMIN_IDS = [1, 4];

// Acceso a la vista ER v2 (/admin/er-v2). Puerta dedicada por-función (precedente
// EDIFICIOS_ADMIN_IDS/EDITORES_PIN): amplía el acceso sin ensanchar ADMIN_IDS.
// Ignacio (Chile=1, Perú=4) + Franco Díaz (id 9, administrativo CHI).
export const ER_V2_IDS = [1, 4, 9];

// Gerencia / dueños — Ignacio (Chile 1 / Perú 4). Puerta dedicada por-función (precedente
// EDITORES_PIN/FORZAR_VINCULACION_IDS): puede divergir de ADMIN_IDS sin tocar a los dueños.
// Gatea la edición de la fecha de pago del sueldo líquido en el flujo (FASE 8.2).
export const GERENTE_IDS = [1, 4];

// Inversores con acceso restringido (solo lectura parcial).
// Vacío: 1623/1624 pasaron a rol broker (su denylist los bloqueaba de ventas-detalle/proyección,
// sus vistas principales). Los inversores reales (1525, 1572) nunca estuvieron acá.
// La constante se mantiene porque App.js y menuConfig.js la importan como deniedIds.
export const INVERSORES_RESTRINGIDOS = [];

// Usuarios que ven todas las ventas en reporte fotográfico
export const USERS_ALL_VENTAS = [1, 4, 7, 306, 904];

// Usuarios con acceso a galería como admin (pueden subir/borrar)
export const GALERIA_ADMIN_IDS = [1, 4, 306, 904];

// Permiso por-función: editar ubicación de pines en /mapa.
// Hoy coincide con ADMIN_IDS pero es independiente y puede divergir.
export const EDITORES_PIN = [1, 4];

// Crear/editar edificios y comisiones (puerta única, Bloque C) — exclusivo Ignacio
// (Chile=1, Perú=4) hasta dominar el subsistema; ampliable después. Constante dedicada
// por-función (sigue el precedente de EDITORES_PIN): puede divergir sin tocar a los dueños.
export const EDIFICIOS_ADMIN_IDS = [1, 4];

// Forzar la vinculación de un movimiento bancario que pagó MENOS que la Σ de facturas
// (faltante): cierra las facturas al 100% con un ajuste interno, deja marca "forzado/
// pendiente" y registra auditoría en vinculaciones_forzadas. Decisión de gerencia —
// exclusivo Ignacio (Chile=1, Perú=4). Puerta dedicada por-función (precedente
// EDIFICIOS_ADMIN_IDS/EDITORES_PIN): puede divergir sin tocar a los dueños.
export const FORZAR_VINCULACION_IDS = [1, 4];

// Asignar/editar los edificios de un usuario rol='edificio' (columna edificiosOk en
// /admin/usuarios). Puerta SEPARADA de EDIFICIOS_ADMIN_IDS a propósito: esto no es CRUD
// de edificios ni comisiones, solo cablear qué edificios ve una cuenta de rol edificio.
// Ignacio (CHI=1, PER=4) + staff que opera edificios: Franco Díaz (id 9, administrativo CHI)
// y Priscilla Munguia (id 7, gerencia PER).
export const EDIFICIOS_ASIGNAR_IDS = [1, 4, 9, 7];

// Vincular clientes a un contacto rol='agencia' (tabla puente usuarios_clientes, modal
// "Clientes vinculados" en /admin/usuarios). Puerta SEPARADA por-función, calcada de
// EDIFICIOS_ASIGNAR_IDS: cablear qué clientes ve un contacto de agencia en el reporte
// fotográfico, no es CRUD de clientes. Staff operativo:
//   1 Ignacio Mailhos (gerencia CHI) · 4 Ignacio Mailhos (gerencia PER)
//   7 Priscilla Munguia (gerencia PER) · 9 Franco Díaz (administrativo CHI)
//   904 Nicolás "Nico" Soto (agencia CHI) · 306 Karin Ulffe (comercial PER)
export const CLIENTES_ASIGNAR_IDS = [1, 4, 7, 9, 904, 306];

// Carga de líneas de inversión (modal "Inversión" del edificio, CapEx planificado).
// Lista dedicada por-función: amplía el alcance más allá de puedeEditarTodo
// (superadmin/gerencia) sin tocar el rol del usuario ni EDIFICIOS_ADMIN_IDS.
// Franco Díaz (id 9, rol administrativo) habilitado para cargar inversión.
export const INVERSION_CARGA_IDS = [9];

// Usuarios que pueden cambiar demo en admin
export const DEMO_SWITCH_IDS = [306, 904];

// Usuarios con acceso a la sección Región
export const REGION_IDS = [1, 4, 7, 306, 749, 750, 751, 752];

// Usuarios con acceso a mailing
export const MAILING_IDS = [1, 4];

// Ejecutivos sin comisión (Chile, 2025+)
export const SIN_COMISION_2025 = [1, 4, 904];

// Agencias de venta directa (0% comisión intermediario)
export const AGENCIAS_DIRECTAS = [16, 32, 60];

// Fecha de activación de la comisión de broker (2ª capa de intermediación).
// Constante dura del gate: ninguna venta anterior a esta fecha lleva broker,
// con independencia de lo que diga el registro del intermediario (gate redundante).
export const BROKER_ACTIVACION = "2026-06-01";

// Agencia AdLab Perú: sus brokers (rol "broker", agencia 115) pueden aplicar
// descuento manual en el cotizador con un tope real combinado (ver más abajo).
export const AGENCIA_ADLAB_PERU = 115;

// Tope DURO del descuento real combinado (automático + manual) sobre la tarifa de
// lista para el broker AdLab Perú. Como el manual se aplica sobre la base ya neta de
// descuentoGlobal, la composición es multiplicativa (ver maxManualFracBroker).
export const BROKER_ADLAB_DESCUENTO_MAX = 0.15;

// Equipo OMNET (negociación especial)
export const OMNET_IDS = [1295, 1296, 1297];

// Edificios excluidos de inventario operativo
export const EDIFICIOS_EXCLUIDOS = [119, 121, 157, 158, 159, 168];

// ──────────────────────────────────────────────
// Helpers
// ──────────────────────────────────────────────
export const isAdmin = (id) => ADMIN_IDS.includes(Number(id));
export const esGerente = (id) => GERENTE_IDS.includes(Number(id));
export const isInversorRestringido = (id) => INVERSORES_RESTRINGIDOS.includes(Number(id));
export const isEdificiosAdmin = (id) => EDIFICIOS_ADMIN_IDS.includes(Number(id));
export const puedeForzarVinculacion = (id) => FORZAR_VINCULACION_IDS.includes(Number(id));
export const puedeAsignarEdificios = (id) => EDIFICIOS_ASIGNAR_IDS.includes(Number(id));
export const puedeAsignarClientes = (id) => CLIENTES_ASIGNAR_IDS.includes(Number(id));
export const puedeCargarInversion = (id) => INVERSION_CARGA_IDS.includes(Number(id));

// Broker AdLab Perú habilitado para descuento manual en el cotizador.
// agencia viene como string en DB → comparar por Number.
export const brokerPuedeDescontar = (rol, agencia) => rol === "broker" && Number(agencia) === AGENCIA_ADLAB_PERU;

// Fracción máxima de descuento manual (sobre baseInversionFinalTotal, ya neta de
// descuentoGlobal) para que el descuento real combinado no supere BROKER_ADLAB_DESCUENTO_MAX.
// descuentoRealTotal = 1 − (1 − descuentoGlobal)(1 − manualFrac) ≤ MAX
//   ⇒ manualFrac ≤ 1 − (1 − MAX) / (1 − descuentoGlobal).
// Si descuentoGlobal ≥ MAX el resultado es ≤ 0 → el broker no puede sumar nada.
export const maxManualFracBroker = (descuentoGlobal) => {
  const g = Number(descuentoGlobal) || 0;
  if (g >= 1) return 0;
  return Math.max(0, 1 - (1 - BROKER_ADLAB_DESCUENTO_MAX) / (1 - g));
};
